export default "static/dist/img/outline-check_circle_outline-24px.svg?bef339e3b3ce0889ae9e2db4644ee4ba";